<template>
  <AppCard design="new" variant="table" header-density="compact" :title="title">
    <AppDataTable design="new" density="dense" :columns="columns" :rows="items" clickable min-width="1200px" @row-click="$emit('action', $event.row)">
      <template #cell-client="{ row }"><AppTableText :text="row.full_name" /></template>
      <template #cell-files="{ row }"><TicketFilesSummary :item="row" :show-statuses="showStatuses" /></template>
      <template #cell-details="{ row }"><FlightDetailsSummary :item="row" /></template>
    </AppDataTable>
  </AppCard>
</template>

<script>
import AppTableText from '@/components/AppTableText.vue'
import FlightDetailsSummary from './FlightDetailsSummary'
import TicketFilesSummary from './TicketFilesSummary'

const columns = [
  { key: 'client', label: 'Client', width: '18%' },
  { key: 'files', label: 'Ticket files', width: '42%' },
  { key: 'details', label: 'Client flight data', width: '40%' },
]

export default {
  name: 'TechSupportFlightTicketsTable',
  components: { AppTableText, FlightDetailsSummary, TicketFilesSummary },
  columns,
  props: {
    items: { type: Array, required: true },
    title: { type: String, default: '' },
    showStatuses: { type: Boolean, default: true },
  },
  data() { return { columns } },
}
</script>
